module.exports = __webpack_public_path__ + "img/tx-yonghu.d7230af9.png";